import { z } from "zod";
import {
  supplyPurchaseInputSchema,
  supplyTransferInputSchema,
  supplyUseInputSchema,
} from "@frontier/content/supplies";
import type { Profile } from "@frontier/protocol/contracts";
import type { AuthStorage } from "./auth-storage";

export const supplyIntentSchema = z.discriminatedUnion("operation", [
  z.strictObject({
    operation: z.literal("purchase"),
    input: supplyPurchaseInputSchema,
  }),
  z.strictObject({
    operation: z.literal("transfer"),
    input: supplyTransferInputSchema,
  }),
]);
export type SupplyIntent = z.infer<typeof supplyIntentSchema>;
export function readSupplyIntent(raw: string | null): SupplyIntent | null {
  try {
    const value = supplyIntentSchema.safeParse(raw ? JSON.parse(raw) : null);
    return value.success ? value.data : null;
  } catch {
    return null;
  }
}
export function readSupplyUse(raw: string | null) {
  try {
    const value = supplyUseInputSchema.safeParse(raw ? JSON.parse(raw) : null);
    return value.success ? value.data : null;
  } catch {
    return null;
  }
}
export function sameSupplyContext(
  left: Pick<Profile, "runId" | "hullId" | "hullRevision">,
  right: Pick<Profile, "runId" | "hullId" | "hullRevision">,
): boolean {
  return (
    left.hullRevision !== undefined &&
    left.runId === right.runId &&
    left.hullId === right.hullId &&
    left.hullRevision === right.hullRevision
  );
}
export function archiveSupplyIntent(
  storage: AuthStorage,
  key: string,
  raw: string,
  archiveId: string,
): void {
  // Preserve the exact old payload before the player explicitly resumes with the current stock.
  storage.setItem(`${key}.archived.${archiveId}`, raw);
  if (storage.getItem(key) === raw) storage.removeItem(key);
}
